import { useState } from "react";
import AddPromotion from "./add_promotion";
import EditPromotion from "./edit_promotion";

function PromotionTable({
  state,
  active,
  addPromotion,
  updatePromotion,
  showExpired,
  setShowExpired,
}) {
  const [openAddPromotion, setOpenAddPromotion] = useState(false);
  const [selectedEdit, setSelectedEdit] = useState(null);
  return (
    <div className="px-4 sm:px-6 lg:px-8 pt-6 w-full">
      <div className="sm:flex sm:items-center">
        <div className="sm:flex-auto">
          <h1 className="text-base font-semibold text-gray-900">
            Promotional Codes
          </h1>
        </div>
        <div className="mt-4 sm:ml-16 sm:mt-0 flex gap-4">
          <button
            onClick={() => setShowExpired(!showExpired)}
            type="button"
            className="block rounded-md bg-indigo-600 px-3 py-2 text-center text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
          >
            {showExpired ? "Hide" : "Show"} Expired
          </button>
          <button
            onClick={() => setOpenAddPromotion(!openAddPromotion)}
            type="button"
            className="block rounded-md bg-indigo-600 px-3 py-2 text-center text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
          >
            Add Promotion
          </button>
        </div>
      </div>
      <AddPromotion
        open={openAddPromotion}
        setOpen={setOpenAddPromotion}
        addPromotion={addPromotion}
      />
      <EditPromotion
        open={selectedEdit !== null}
        onClose={() => setSelectedEdit(null)}
        promotion={selectedEdit}
        updatePromotion={updatePromotion}
      />
      <Table
        showExpired={showExpired}
        state={state}
        active={active}
        setSelectedEdit={setSelectedEdit}
      />
    </div>
  );
}
function Table({ showExpired, state, active, setSelectedEdit }) {
  return (
    <div className="-mx-4 mt-8 sm:-mx-0">
      <table className="min-w-full divide-y divide-gray-300">
        <thead>
          <tr>
            <th
              scope="col"
              className="py-3.5 pl-4 pr-3 text-center text-sm font-semibold text-gray-900 sm:pl-0"
            >
              Code
            </th>
            <th
              scope="col"
              className="px-3 py-3.5 text-center text-sm font-semibold text-gray-900 lg:table-cell"
            >
              Type
            </th>
            <th
              scope="col"
              className="px-3 py-3.5 text-center text-sm font-semibold text-gray-900 sm:table-cell"
            >
              Modifier
            </th>
            <th
              scope="col"
              className="px-3 py-3.5 text-center text-sm font-semibold text-gray-900"
            >
              Expiration Date
            </th>
            <th
              scope="col"
              className="px-3 py-3.5 text-center text-sm font-semibold text-gray-900"
            >
              Countdown
            </th>
            <th scope="col" className="relative py-3.5 pl-3 pr-4 sm:pr-0">
              <span className="sr-only">Edit</span>
            </th>
          </tr>
        </thead>
        <tbody className="divide-y divide-gray-200 bg-white">
          {(showExpired ? state : active).map((discount_code) => (
            <tr key={discount_code.discount_code_id}>
              <td className="w-full max-w-0 py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:w-auto sm:max-w-none sm:pl-0">
                {discount_code.discount_identifier}
              </td>
              <td className="px-3 py-4 text-sm text-gray-500">
                {getTypeName(discount_code.discount_type)}
              </td>
              <td className="py-4 pl-3 pr-4 text-center text-sm font-medium sm:pr-0">
                {getModifier(
                  discount_code.discount_type,
                  discount_code.discount_modifier
                )}
              </td>
              <td className="py-4 pl-3 pr-4 text-center text-sm font-medium sm:pr-0">
                {new Date(discount_code.expiration_date).toUTCString()}
              </td>
              <td className="py-4 pl-3 pr-4 text-center text-sm font-medium sm:pr-0">
                {formatMilliseconds(
                  new Date(discount_code.expiration_date) - new Date()
                )}
              </td>
              <td className="text-indigo-600 hover:text-indigo-900">
                <button onClick={() => setSelectedEdit(discount_code)}>
                  Edit
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
function getModifier(type, mod) {
  if (type === 0) return mod;
  if (type === 1) return `${mod}% off`;
  if (type === 2) return `$${mod / 100} off`;
  if (type === 3) return "Tiered";
  if (type === 4) return "Athelete / Fundraiser";
}
function getTypeName(type) {
  if (type === 0) return "~undefined~";
  if (type === 1) return "Percent";
  if (type === 2) return "Flat Rate";
  if (type === 3) return "Tiered";
  if (type === 4) return "Athelete / Fundraiser";
}
function formatMilliseconds(ms) {
  const days = Math.floor(ms / 86400000); // 1 day = 86400000 ms
  const hours = Math.floor((ms % 86400000) / 3600000); // 1 hour = 3600000 ms

  return `${days} days, ${hours} hours`;
}

export default PromotionTable;
